interface LabelValue {
  value: string;
  label: string;
}
export const INDUSTRY_OPTIONS: Record<string, LabelValue> = {
  manufacturing: {
    value: "manufacturing",
    label: "製造業",
  },
  wholesale: {
    value: "wholesale",
    label: "卸売業",
  },
  retail: {
    value: "retail",
    label: "小売業",
  },
  construction: {
    value: "construction",
    label: "建設業",
  },
  transportation: {
    value: "transportation",
    label: "運輸業",
  },
  it_communication: {
    value: "it_communication",
    label: "情報通信業",
  },
  finance_insurance: {
    value: "finance_insurance",
    label: "金融・保険業",
  },
  real_estate: {
    value: "real_estate",
    label: "不動産業",
  },
  service: {
    value: "service",
    label: "サービス業",
  },
  agriculture: {
    value: "agriculture",
    label: "農林水産業",
  },
  food_service: {
    value: "food_service",
    label: "飲食業",
  },
  medical: {
    value: "medical",
    label: "医療・福祉",
  },
  education: {
    value: "education",
    label: "教育・学習支援",
  },
  other: {
    value: "other",
    label: "その他",
  },
};
